import { render, staticRenderFns } from "./PostingEdit.vue?vue&type=template&id=7a741013"
import script from "./PostingEdit.vue?vue&type=script&lang=js"
export * from "./PostingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports